<template>
<div class="navs">
    <div class="logo"><img src="../assets/vlogo.jpg" alt="logo" /></div>
    <el-menu mode="vertical" default-active="0" background-color="#496cfc" text-color="#c5d3f8" active-text-color="#fff">
        <el-menu-item index="1">
            <router-link to="/policy"> 学员管理</router-link>
        </el-menu-item>
        <el-menu-item index="2">
            <router-link to="/instro"> 介绍管理</router-link>
        </el-menu-item>
    </el-menu>
</div>
</template>

<script>
export default {
    data() {
        return {
            user: JSON.parse(sessionStorage.getItem("userInfo")).admin,
        };
    },

};
</script>

<style scoped>
.navs {
    height: 100%;
    background-color: #496cfc;
    overflow: hidden;
    overflow-y: auto;
}

.el-menu-item a {
    color: rgb(197 211 248);
    display: block;
}

.el-menu-item.is-active a {
    color: #fff;
}

.logo {
    background-color: #496cfc;
    height: 60px;
    text-align: center;
}

.logo img {
    height: 45px;
    margin-top: 7.5px;
}
</style>
